<script setup lang="ts">
import { PencilSquareIcon, EyeIcon } from '@heroicons/vue/24/outline'
defineProps(['params'])
</script>

<template>
  <div class="flex items-center gap-1 w-full">
    <button
      class="btn btn-ghost btn-sm"
      title="Modifier"
      @click="params.onClickEdit(params.data)"
    >
      <PencilSquareIcon class="w-4 h-4" />
    </button>
    <button
      v-if="params.canImpersonate && params.canImpersonate(params.data)"
      class="btn btn-ghost btn-sm text-warning"
      title="Se connecter en tant que"
      @click="params.onClickImpersonate(params.data)"
    >
      <EyeIcon class="w-4 h-4" />
    </button>
  </div>
</template>
